export default {
  SET_PENDING_STATUS: 'SET_PENDING_STATUS',
};
